import React, { useEffect, useState } from 'react';
import client from '../../api/client';
import { card, inputCls, btnCls } from './LegalConfigEditor';

const DOCS = [['terms', 'Terms of Service'], ['privacy', 'Privacy Policy'], ['sms_terms', 'SMS Terms'], ['cookies', 'Cookie Notice']];

export default function DocPublisher({ config, toast, onPublished }) {
  const [versions, setVersions] = useState([]);
  const [f, setF] = useState({ doc: 'terms', version: '', effective_date: new Date().toISOString().slice(0, 10), change_summary: '' });
  const load = () => client.get('/admin/compliance/versions').then(({ data }) => setVersions(data.versions)).catch(() => {});
  useEffect(() => { load(); }, []);

  const publish = async () => {
    try {
      await client.post('/admin/compliance/publish', f);
      toast({ title: 'New version published' });
      setF({ ...f, version: '', change_summary: '' });
      load(); onPublished?.();
    } catch (e) {
      toast({ title: 'Could not publish', description: e.message, variant: 'destructive' });
    }
  };

  return (
    <section data-testid="doc-publisher" className={card + ' space-y-3'}>
      <h3 className="font-serif text-xl text-[#2A2A2A]">Document versions</h3>
      <div className="grid grid-cols-2 gap-2 text-xs">
        {DOCS.map(([k, label]) => (
          <div key={k} data-testid={`doc-current-${k}`} className="rounded-xl bg-[#FBF7F2] border border-[#EFE3D8] px-3 py-2">
            <p className="text-[#2A2A2A] font-medium">{label}</p>
            <p className="text-[#9A8A7E]">v{config[`${k}_version`]} · effective {config[`${k}_effective_date`]}</p>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-2">
        <select data-testid="publish-doc" value={f.doc} onChange={(e) => setF({ ...f, doc: e.target.value })} className={inputCls}>
          {DOCS.map(([k, label]) => <option key={k} value={k}>{label}</option>)}
        </select>
        <input data-testid="publish-version" placeholder="e.g. 1.1" value={f.version} onChange={(e) => setF({ ...f, version: e.target.value })} className={inputCls} />
        <input data-testid="publish-date" type="date" value={f.effective_date} onChange={(e) => setF({ ...f, effective_date: e.target.value })} className={inputCls} />
      </div>
      <input data-testid="publish-summary" placeholder="What changed?" value={f.change_summary} onChange={(e) => setF({ ...f, change_summary: e.target.value })} className={inputCls} />
      <button data-testid="publish-submit" disabled={!f.version} onClick={publish} className={btnCls}>Publish version</button>
      {versions.length > 0 && (
        <ul data-testid="publish-history" className="text-xs divide-y divide-[#F2E8DE] max-h-48 overflow-auto">
          {versions.map((v) => (
            <li key={v.id} className="py-2">
              <span className="font-medium">{v.doc}</span> v{v.previous_version} → v{v.version} · {v.effective_date}
              <span className="text-[#9A8A7E]"> · {v.published_by}</span>
              {v.change_summary && <p className="text-[#6A6A6A]">{v.change_summary}</p>}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
